import * as React from "react";
import { AccountForm } from "../NotifierForm/AccountForm";
import { identity } from "lodash";
import { Account } from "@/types/index";
import { makeDocument } from "@/mock-data";
import { SPContext } from "@/store/SPProvider";
import { createExpressDocument } from "@/services/api/document-api";

export type CIMultiAccountDetail = {
  account: Account | undefined;
  readonly onBtnClickAdd: any;
  readonly onBtnClickBack: any;
  readonly updateTemplate: any;
  readonly updateTemplateDelegate: any;
};

export const MultiAccountDetail: React.FunctionComponent<CIMultiAccountDetail> = ({
  account,
  onBtnClickAdd,
  onBtnClickBack,
  updateTemplate,
  updateTemplateDelegate,
}) => {
  const { state: serviceProvider } = React.useContext(SPContext);

  React.useEffect(() => {
    updateTemplate((s: any) => {
      return {
        ...s,
        nestedFunc: true,
        onBack: () => onBtnClickBack(),
        onSectionClick: null,
      };
    });
  }, [onBtnClickBack, updateTemplate]);

  return (
    <AccountForm
      caseId={""} // TODO: remove
      signature={""} // TODO: remove
      serviceProvider={{ id: "id", ...serviceProvider }}
      serviceProviders={[]}
      properties={[]}
      // @ts-ignore
      persons={[{ id: "notifier", title: "", firstName: "Myself", lastName: "" }]}
      setBusy={identity}
      onAccountUpdated={identity} // TODO
      uploadedFileInfo={() => Promise.resolve(makeDocument())}
      createDocument={createExpressDocument}
      updateTemplate={updateTemplateDelegate}
      savedRecord={account}
      saveRecord={onBtnClickAdd}
    />
  );
};
